import styled from 'styled-components';
import * as React from 'react';

const AddAmountButton = (props: Props) => {
	return (
		<AddAmountContainer onClick={() => props.onClick(props.additionalAmount)}>
			+${props.additionalAmount}
		</AddAmountContainer>
	);
};

interface Props {
	additionalAmount: number;
	onClick: (additionalAmount: number) => void;
}

const AddAmountContainer = styled.button`
	width: 68px;
	height: 35px;
	border-radius: 5px;
	border: 1px solid #dde1e3;
	color: #000;
	font-size: 14px;
	font-weight: bold;
`;

export default AddAmountButton;
